import { staticRoutes } from 'core/use-cases/settings/slice/static-routes';
import { useLocation, matchPath } from 'react-router';

export const useRouterCurrent = () => {
  const { pathname } = useLocation();

  const router = staticRoutes.find((route) => {
    const match = matchPath({ path: route.path }, pathname);

    return match;
  });

  return {
    ...router,
  };
};
